import { useEffect, useState } from 'react'

import {
  hasGpcSignal,
  readConsentRecord,
  resolveEffectiveConsent,
  type ConsentState,
} from '@ui/lib/consent'

export interface ConsentSnapshot {
  state: ConsentState
  hasDecision: boolean
  gpc: boolean
}

// Null until mounted: the server can't read the cookie.
export function useConsent(): ConsentSnapshot | null {
  const [consent, setConsent] = useState<ConsentSnapshot | null>(null)
  useEffect(() => {
    const record = readConsentRecord()
    const gpc = hasGpcSignal()
    setConsent({
      state: resolveEffectiveConsent({ record, gpc }),
      hasDecision: record !== undefined,
      gpc,
    })
  }, [])
  return consent
}
